import { render, staticRenderFns } from "./BookingFaqs.vue?vue&type=template&id=2aa976a3&scoped=true&"
import script from "./BookingFaqs.vue?vue&type=script&lang=js&"
export * from "./BookingFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa976a3",
  null
  
)

export default component.exports